/**
 * Map between Salary Structure UI shape and salary_structure_templates DB rows.
 */

import { normalizeStructureComponents } from "../../../../../utils/salaryStructureComponentRules";
import {
  normalizeNpsConfig,
  normalizeVpfConfig,
  normalizeMealVoucherConfig,
  normalizePerformanceBonusConfig,
  defaultNpsConfig,
  defaultVpfConfig,
  defaultMealVoucherConfig,
} from "../../../../../utils/salaryStructureAddons";

export function structureToTemplatePayload(structureData) {
  const salaryType = String(structureData.salaryType || "ctc").toLowerCase();
  const components = normalizeStructureComponents(
    Array.isArray(structureData.components) ? structureData.components : []
  );
  return {
    name: String(structureData.name || "").trim(),
    mode: salaryType === "gross" ? "GROSS" : "CTC",
    defaultCityType: structureData.defaultCityType || "METRO",
    active: structureData.active !== false,
    componentsJson: {
      components,
      assignment: structureData.assignment || {},
      effectiveMonth: structureData.effectiveMonth || "",
      performanceBonus: normalizePerformanceBonusConfig(structureData.performanceBonus),
      nps: normalizeNpsConfig(structureData.nps),
      vpf: normalizeVpfConfig(structureData.vpf),
      mealVoucher: normalizeMealVoucherConfig(structureData.mealVoucher),
    },
  };
}

export function templateToStructure(template) {
  if (!template) return null;
  const raw = template.componentsJson;
  let components = [];
  let assignment = {};
  let effectiveMonth = "";
  let performanceBonus = normalizePerformanceBonusConfig({ enabled: false, frequency: "annual" });
  let nps = defaultNpsConfig();
  let vpf = defaultVpfConfig();
  let mealVoucher = defaultMealVoucherConfig();

  if (Array.isArray(raw)) {
    components = raw;
  } else if (raw && typeof raw === "object") {
    components = Array.isArray(raw.components) ? raw.components : [];
    assignment = raw.assignment || {};
    effectiveMonth = raw.effectiveMonth || "";
    performanceBonus = normalizePerformanceBonusConfig(raw.performanceBonus);
    nps = normalizeNpsConfig(raw.nps);
    vpf = normalizeVpfConfig(raw.vpf);
    mealVoucher = normalizeMealVoucherConfig(raw.mealVoucher);
  }

  return {
    id: template.id,
    name: template.name,
    salaryType: String(template.mode || "CTC").toUpperCase() === "GROSS" ? "gross" : "ctc",
    components: normalizeStructureComponents(components),
    assignment,
    effectiveMonth,
    performanceBonus,
    nps,
    vpf,
    mealVoucher,
    active: template.active !== false,
    createdAt: template.createdAt || template.created_at || null,
    updatedAt: template.updatedAt || template.updated_at || null,
    _template: template,
  };
}
